import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { Box } from '@mui/material';
import { ListTable } from '../../molecules/ListTable';
import { IBooking } from '../../../utils/entities/interface';
import {
  capitalizeWords,
  DateDDMMYYYY,
  formatPhoneNumber,
  getStatusLabel,
} from '../../../utils/helper';
import { ServiceTypesCell } from './ServiceTypesCell';

const shouldHighlightBookingDate = (enquiryTab?: string) =>
  enquiryTab === 'OLD_ENQUIRES' || enquiryTab === 'COMPLETED';

const shouldHighlightStatus = (enquiryTab?: string) => enquiryTab === '';

const highlightedTextSx = { color: '#FFFFFF', fontWeight: 600 } as const;

const renderBookingSlot = (booking: IBooking, highlightDate: boolean) => {
  const dateStr = booking?.date ? DateDDMMYYYY(booking.date) : 'N/A';
  const slotStr =
    booking?.slot === 'FIRST_HALF'
      ? '1st'
      : booking?.slot === 'SECOND_HALF'
        ? '2nd'
        : 'N/A';

  if (!highlightDate) {
    return `${dateStr} - ${slotStr}`;
  }

  return (
    <Box component="span">
      <Box component="span" sx={{ color: '#FFFFFF', fontWeight: 600 }}>
        {dateStr}
      </Box>
      {` - ${slotStr}`}
    </Box>
  );
};

export const BookingList = ({
  bookings,
  isLoading,
  onManageClick,
  onlyview,
  headerCells,
  enquiryTab,
}: {
  bookings: IBooking[];
  isLoading: boolean;
  onManageClick: (id: string) => void;
  onlyview?: boolean;
  headerCells: [string, number][];
  enquiryTab?: string;
}) => {
  const highlightBookingDate = shouldHighlightBookingDate(enquiryTab);
  const highlightStatus = shouldHighlightStatus(enquiryTab);
  const actions = [
    {
      icon: <RemoveRedEyeOutlinedIcon />,
      onClick: (row: IBooking) => onManageClick(row._id),
    },
    // !onlyview && {
    //   icon: <BorderColorOutlinedIcon />,
    //   onClick: (row: IBooking) =>
    //     window.open(`/bookings/edit/${row._id}`, '_self'),
    // },
    // !onlyview && {
    //   icon: <EngineeringOutlinedIcon />,
    //   onClick: (row: IBooking) =>
    //     window.open(`/bookings/assign/${row._id}`, '_self'),
    // },
  ].filter(Boolean) as any[];

  return (
    <ListTable
      headerCells={headerCells}
      rows={bookings}
      isLoading={isLoading}
      actions={actions}
      renderCell={(booking: IBooking, colIndex: number) => {
        if (colIndex === 6) {
          const statusLabel = getStatusLabel(booking.status);
          if (!highlightStatus) {
            return statusLabel;
          }
          return (
            <Box component="span" sx={highlightedTextSx}>
              {statusLabel}
            </Box>
          );
        }

        switch (colIndex) {
          case 0:
            return booking.bookingId || '-';
          case 1:
            return capitalizeWords(booking.user.name) || 'N/A';
          case 2:
            return <ServiceTypesCell booking={booking} />;
          case 3:
            return capitalizeWords(booking.technicianName.name) || 'N/A';
          case 4:
            return formatPhoneNumber(booking.user.phoneNumber);
          case 5:
            return renderBookingSlot(booking, highlightBookingDate);
          default:
            return null;
        }
      }}
    />
  );
};
